import { Component, computed, inject, Input, OnInit, signal } from '@angular/core';
import { AlertsApiService } from "@shared/services/alerts-api.service";
import { AuthService } from "../../../core/services/auth.service";
import { NgbDropdown, NgbDropdownItem, NgbDropdownMenu, NgbDropdownToggle } from "@ng-bootstrap/ng-bootstrap";
import { AsyncPipe, DatePipe } from "@angular/common";
import { MenuService } from "../../../shared/services/menu.service";
import { OrganisationApiService } from '@shared/services/organisation-api.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { catchError, map, of, shareReplay } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { AlertsService } from "../../../shared/services/alert.service";
import { Router, RouterLink } from "@angular/router";
import { DividerComponent } from "@shared/components/commons/divider/divider.component";
import { AlertStatus } from "@models/alerts/alerts-enums";
import { IHeaderData } from "../../../shared/services/header.service";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterLink,
    DatePipe,
    AsyncPipe,
    NgbDropdownToggle,
    NgbDropdownItem,
    NgbDropdownMenu,
    NgbDropdown,
    DividerComponent,
  ],
  templateUrl: 'header.component.html',
  styleUrl: 'header.component.scss'
})
export class HeaderComponent implements OnInit {
  private authService = inject(AuthService);
  private menuService = inject(MenuService);
  private organisationService = inject(OrganisationApiService);
  private alertsService = inject(AlertsService);
  private alertsApiService = inject(AlertsApiService);
  private router = inject(Router);
  private sanitizer = inject(DomSanitizer);

  @Input() headerData: IHeaderData | null = null;

  readonly AlertStatus = AlertStatus;

  organisationName = computed(() => this.authService.currentUserProfile()?.organisationName);
  availableOrganisations = computed(() => this.authService.currentUserProfile()?.availableOrganisations ?? []);
  collapsedMenu = this.menuService.collapsedMenu;
  logo = this.authService.profile.organisationSetupRequired ? signal('assets/svg/bolt-logo-icon.svg') :
    toSignal(this.organisationService.headerLogoLoader
      .pipe(map(b => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(b))))
      .pipe(catchError(() => of('assets/svg/bolt-logo-icon.svg'))));

  alerts$ = this.authService.profile.organisationSetupRequired ? of([]) : this.alertsApiService.getBellInboxAlert().pipe(shareReplay(1));
  greenAlert$ = this.alerts$.pipe(
    map(alerts => alerts?.every((alert) => alert.indicator === 'green')),
    shareReplay(1)
  );

  ngOnInit(): void {
    this.alertsService.readStatusUpdated$
      .subscribe({
        next: () => {
          this.alerts$ = this.alertsApiService.getBellInboxAlert()
            .pipe(shareReplay(1));

          this.greenAlert$ = this.alerts$.pipe(
            map(alerts => alerts?.every((alert) => alert.indicator === 'green')),
            shareReplay(1)
          );
        }
      });
  }

  async changeOrganization(organisationExternalId: string): Promise<void> {
    await this.authService.login(organisationExternalId);
  }

  displayAlert(alertId: string): void {
    void this.router.navigate(['alerts/inbox'], { queryParams: { alertId: alertId } });
  }

  help(): void {
    console.log('Help click');
  }

  async logOut(): Promise<void> {
    await this.authService.logOut();
  }
}
